import React from "react";
import styled from "@emotion/styled";

import { paidIcons } from "../../../lib/icons/PlanIcon";
import UIcon from "../../../lib/icons/untitled_ui/UIcon";
import { sysBorderDecorative, sysWarningSubtle } from "../../../lib/themes/colors";
import { Flex, Text } from "../../../styles/utility-components";

interface PaidContentBannerProps {
  paidPlanType: "basic" | "bidPart" | "tenderPart" | "pipelinePart" | "strategyPart";
  description: React.ReactNode;
  backgroundColor?: string;
  contentAlign?: "center" | "left";
  iconSize?: number;
}

function PaidContentBanner({
  paidPlanType,
  description,
  backgroundColor = sysWarningSubtle,
  contentAlign = "center",
  iconSize = 16,
}: PaidContentBannerProps) {
  return (
    <Wrapper backgroundColor={backgroundColor}>
      <Flex justifyContent={contentAlign} alignItems="center" gap="8px">
        <UIcon svg={paidIcons[paidPlanType]} size={iconSize} />
        <Text>{description}</Text>
      </Flex>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ backgroundColor: string }>(({ backgroundColor }) => ({
  borderBottom: sysBorderDecorative,
  backgroundColor: backgroundColor,
  padding: "16px 24px",
}));

export default PaidContentBanner;
